import { metaSliceActions } from "./metaSlice"

export const metaActions = {
    ...metaSliceActions,
}
